module.exports = __webpack_public_path__ + "static/media/Roboto-Bold.16d7bb99.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-Bold.ttf
// module id = 533
// module chunks = 0